:host {
  display: block;
  max-height: 400px;
  overflow: auto;
  padding-top: 5px;
  padding-bottom: 60px;

  hr {
    border: 0;
    border-bottom: 1px solid var(--av-card-separator-color);
    margin: 0;
  }

  .timeslot-title {
    margin-block: 0.8em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .calendar {
    .av-card-body {
      padding: 0px;
    }
  }

  .av-calendar {
    font-size: 0.9em;
    // border: 1px solid var(--av-card-separator-color);
    // border-radius: var(--av-border-radius-container);
    // box-shadow: var(--av-box-shadow-container);
  }

  .timeslot-progress {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    font-size: 0.9em;
    .timeslot-progress-step {
      padding: 10px 20px;
    }
  }

  .timeslot-container {
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: max-content;
  }

  .timeslot {
    @include option-panel;
    box-sizing: border-box;
    padding: 8px 0;
    margin: 0;
    cursor: pointer;
    color: var(--av-card-color);
    &:focus-visible{
      outline-color: var(--av-color-focus-outline);
    }
  }

  .text-muted {
    opacity: 0.5;
  }

  .container-empty {
    padding: 20px 10px;
    text-align: center;
    opacity: 0.6;
    font-weight: bold;
  }

  .container-spinner {
    text-align: center;
    transform: scale(0.5);
  }

  .actions {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 0 0 var(--av-border-radius-container)
      var(--av-border-radius-container);
    &.actions-overflow {
      background: var(--av-card-background-color);
    }
  }
}

app-schedule-contact {
  margin-top: 10px;
}

.av-direction {
  direction: var(--av-direction);
}
